
export const arrayItems = [
    {
        name: "Marv with the honest answers",
        id: "marv",
        preprompt: "Marv,\n ",
        description: "He's a straight shooter",
        option: {
            model: "text-davinci-003",
            temperature: 0.5,
            max_tokens: 300,
            top_p: 0.3,
            frequency_penalty: 0.5,
            presence_penalty: 0.0,
        },
    },
    {
        name: "Recipe Creator",
        id: "recipes",
        description: "Create a recipe from a list of ingredients",
        preprompt: "Make a Recipe and name it:\n ",
        option: {
            model: "text-davinci-003",
            temperature: 0.3,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        }
    },
    {
        name: "Chat",
        id: "chat",
        description: "Have an open ended conversation with an AI assistant",
        option: {
            model: "text-davinci-003",
            temperature: 0.9,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.6,
            stop: [" Human", " AI:"],
        }
    },
    {
        name: "Micro Horror Story Creator",
        id: "MHScreator",
        description: "Creates a two to three sentence short horror stories from a topic input.",
        preprompt: "Write a 3 sentence Scary story with these parameters: \n",
        option: {
            model: "text-davinci-003",
            temperature: 0.8,
            max_tokens: 200,
            top_p: 1.0,
            frequency_penalty: 0.5,
            presence_penalty: 0.0,
        },
    },
    {
        name: 'Q&A',
        id: "q&a",
        description: "Answer questions based on existing knowledge.",
        preprompt: "Ask a question: \n",
        option: {
            model: "text-davinci-003",
            temperature: 0,
            max_tokens: 300,
            top_p: 1,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        },
    },
    {
        name: "Grammar Correction",
        id: "grammarCorrection",
        description: "Corrects sentances into standard English.",
        preprompt: "Please Correct this Grammar, \n",
        option: {
            model: "text-davinci-003",
            temperature: 0,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        },
        
    },
    {
        name: "Summarize for a 2nd Grader",
        id: "summary",
        description: "Translates difficult text into simplier concepts.",
        preprompt:"Explain this to a second grader: \n",
        option: {
            model: "text-davinci-003",
            temperature: 0.7,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        }
    },
    {
        name: "English to other languages",
        id: "translate",
        description:"Translates English text into French, Spanish, and Japanese.",
        preprompt: "Translate the following into the specified language \n",
        option: {
            model: "text-davinci-003",
            temperature: 0.3,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        },
    },
    {
        name: "Movie to Emoji",
        id: "movieToEmoji",
        description: "Convert Movie Titles into emoji.",
        preprompt: "Convert this Movie Title to emoji: \n",
        option: {
            model: "text-davinci-003",
            temperature: 0.8,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        },
    },
    {
        name: "Explain this Code",
        id:"explainCode",
        description: "Explain a complicated piece of Code.",
        preprompt: "Explain the following piece of code: \n",
        option: {
            model: "code-davinci-002",
            temperature: 0,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        },
    },
    {
        name: "Javascript to Python",
        id: "jstopy",
        description: "Convert simple JavaScript expressions to Python.",
        preprompt: "Convert the following code to Python: \n",
        option: {
            model: "code-davinci-002",
            temperature: 0,
            max_tokens: 300,
            top_p: 1.0,
            frequency_penalty: 0.0,
            presence_penalty: 0.0,
        },
    },
];